import { TransactionType } from '@shared/transactions-types';

import { isType } from './isType';

export const isCardPaymentTransaction = isType(
    TransactionType.CREDIT_CARD,
    TransactionType.POS_PAYMENT,
);
